/**
 * 监听 scrollEnd 事件
 * @date 2020-04-02
 * @author Kody
 */
import { useEffect, useRef } from 'react';
import { $window, docElement } from '@umu/umu-dom';

let scrollTop = docElement.scrollTop;
let doing = false;
let distance = 0;

export const useScrollEnd = (
    callback: (direction: number, container: Element) => void,
    depend: any[] = [],
    ele?: Element | string
) => {
    const callbackRef = useRef(callback);
    callbackRef.current = callback;
    let timer: number = 0;

    const scroll = (container: Element) => {
        if (timer) {
            $window.clearTimeout(timer);
        }
        scrollTop = container.scrollTop;
        if (!doing) {
            distance = scrollTop;
        }
        doing = true;
        timer = $window.setTimeout(() => {
            const newScroppTop = container.scrollTop;
            if (scrollTop === newScroppTop) {
                doing = false;
                callbackRef.current(newScroppTop - distance, container);
            }
        }, 300);
    };

    useEffect(() => {
        const $ele = typeof ele === 'string' ? document.querySelector(ele) : ele;
        const viewer = $ele || $window;
        const container = $ele || docElement;
        const cb = () => scroll(container);
        viewer.addEventListener('scroll', cb);
        return () => {
            viewer.removeEventListener('scroll', cb);
        };
    }, [...depend, ele]);
};
